import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";
import { CLIENTS } from "@/i18n";

const Clients = () => {
  const { t, lang } = useLang();

  return (
    <section
      id="clients"
      className="relative px-6 md:px-10 py-24 md:py-32 border-t border-white/10"
      data-testid="clients-section"
    >
      <div className="max-w-[1500px] mx-auto">
        <div className="text-xs uppercase tracking-[0.3em] text-[#ff00cc] mb-6">
          {t.sectionLabels.clients}
        </div>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="font-display text-[10vw] md:text-6xl lg:text-7xl whitespace-pre-line max-w-4xl"
          data-testid="clients-title"
        >
          {t.clients.title}
        </motion.h2>
        <p className="mt-6 text-white/60 max-w-2xl text-base md:text-lg leading-relaxed">
          {t.clients.sub}
        </p>

        <div className="mt-16 border-t border-white/10">
          {CLIENTS.map((c, i) => (
            <motion.a
              key={c.name}
              href={c.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="group flex items-center justify-between py-7 md:py-10 border-b border-white/10 hover:px-4 transition-all duration-300"
              data-testid={`client-link-${c.name.replace(/\./g, "-")}`}
            >
              <div className="flex items-baseline gap-6 md:gap-10 flex-wrap">
                <span className="font-display text-xs md:text-sm text-white/40 w-8">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="font-display text-3xl md:text-5xl lg:text-6xl group-hover:text-[#ccff00] transition">
                  {c.name}
                </span>
                <span className="hidden md:inline text-white/50 text-sm">
                  {c.desc[lang]}
                </span>
              </div>
              <div className="flex items-center gap-3 text-sm text-white/50 group-hover:text-[#ccff00] transition shrink-0">
                <span className="hidden md:inline">{t.clients.visit}</span>
                <ArrowUpRight
                  size={28}
                  className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1"
                />
              </div>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
